import { getCompanyContact, useApiQuery } from '@hum/api';

export const useCompanyContact = (companyId?: string) => {
  const {
    data: queryCompanyContact,
    isLoading: companyContactIsLoading,
  } = useApiQuery(getCompanyContact, {
    params: { companyId: companyId! },
    enabled: !!companyId,
  });

  return {
    data: queryCompanyContact,
    loaded: !companyContactIsLoading,
  };
};
